import { py11, minHeight48, minHeight40 } from './styles.js';
import { InputAdornmentEnum } from './types.js';

var _pill, _square, _pill2, _square2;
var INPUT_ADORNMENT_SPACING_CONFIG = {
  large: {
    pill: (_pill = {}, _pill[InputAdornmentEnum.Both] = {
      multiline: py11,
      root: 'ps-20 pe-16'
    }, _pill[InputAdornmentEnum.End] = {
      input: 'ps-20',
      multiline: py11,
      root: 'pe-16'
    }, _pill[InputAdornmentEnum.None] = {
      input: 'ps-20 pe-16',
      inputMultiline: py11
    }, _pill[InputAdornmentEnum.Start] = {
      input: 'pe-16',
      multiline: py11,
      root: 'ps-20'
    }, _pill),
    square: (_square = {}, _square[InputAdornmentEnum.Both] = {
      multiline: py11,
      root: 'px-12'
    }, _square[InputAdornmentEnum.End] = {
      input: 'ps-16',
      multiline: py11,
      root: 'pe-12'
    }, _square[InputAdornmentEnum.None] = {
      input: 'px-16',
      inputMultiline: py11
    }, _square[InputAdornmentEnum.Start] = {
      input: 'pe-16',
      multiline: py11,
      root: 'ps-12'
    }, _square)
  },
  medium: {
    pill: (_pill2 = {}, _pill2[InputAdornmentEnum.Both] = {
      multiline: 'py-8',
      root: 'px-16'
    }, _pill2[InputAdornmentEnum.End] = {
      input: 'ps-16',
      multiline: 'py-8',
      root: 'pe-16'
    }, _pill2[InputAdornmentEnum.None] = {
      input: 'px-16',
      inputMultiline: 'py-8'
    }, _pill2[InputAdornmentEnum.Start] = {
      input: 'pe-16',
      multiline: 'py-8',
      root: 'ps-16'
    }, _pill2),
    square: (_square2 = {}, _square2[InputAdornmentEnum.Both] = {
      multiline: 'py-8',
      root: 'px-12'
    }, _square2[InputAdornmentEnum.End] = {
      input: 'ps-16',
      multiline: 'py-8',
      root: 'pe-12'
    }, _square2[InputAdornmentEnum.None] = {
      input: 'px-16',
      inputMultiline: 'py-8'
    }, _square2[InputAdornmentEnum.Start] = {
      input: 'pe-16',
      multiline: 'py-8',
      root: 'ps-12'
    }, _square2)
  }
};
var INPUT_SHAPE_CLASSES = {
  pill: 'rounded-full',
  square: 'rounded-8'
};
var INPUT_SIZE_CLASSES = {
  large: minHeight48,
  medium: minHeight40
};
var DEFAULT_INPUT_TYPOGRAPHY_VARIANT = {
  large: 'body-short-01',
  medium: 'body-short-02'
};
var INPUT_APPEARANCE_CLASSES = {
  filled: 'border border-solid bg-bg-tertiary border-transparent hover:bg-field focus-within:bg-field hover:focus-within:bg-field',
  outline: 'border border-solid bg-bg-primary border-field hover:border-border-dark focus-within:border-focus-primary hover:focus-within:border-focus-primary'
};
var INPUT_DISABLED_CLASSES = {
  filled: '',
  outline: 'bg-bg-secondary'
};

export { DEFAULT_INPUT_TYPOGRAPHY_VARIANT, INPUT_ADORNMENT_SPACING_CONFIG, INPUT_APPEARANCE_CLASSES, INPUT_DISABLED_CLASSES, INPUT_SHAPE_CLASSES, INPUT_SIZE_CLASSES };
//# sourceMappingURL=consts.js.map
